import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import MyContext from "../context/MyContext";
import Loading from "../components/Loading";

const AdminRoute = ({ path, component, redirectTo = "/login" }) => {
  const { user, authIsDone } = useContext(MyContext);

  if (!authIsDone) return <Loading />;
  if (authIsDone) {
    return user && user.role === 1 ? (
      <Route path={path} component={component} />
    ) : (
      <Redirect to={redirectTo} />
    );
  }
};

export default AdminRoute;
